var render = function render(){var _vm=this,_c=_vm._self._c;return _c('edit-patient',{attrs:{"jump":"","type":_vm.$route.query.flag}})
}
var staticRenderFns = []

export { render, staticRenderFns }